import { FC } from 'react';

import { GroupAwardExam, GroupAwardsItem } from 'store/candidate/types';

import { FormFields } from '@britishcouncil/react-forms';
import { TnCCheckbox } from '@britishcouncil/react-solas-ors3';

export const GroupAward: FC<{ fields: FormFields<GroupAwardExam>; groupAward: GroupAwardsItem }> = ({
  fields,
  groupAward,
}) => {
  return (
    <>
      <TnCCheckbox {...fields.isSelected}>
        <strong>
          Apply for {groupAward.name} (Additional fee {groupAward.fee} {groupAward.currency})
        </strong>
      </TnCCheckbox>
    </>
  );
};
